import * as Sentry from '@sentry/vue'

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()
  const rawId = String(config.public.glitchtipWebsiteId || '').trim()
  const rawProjectId = String(config.public.glitchtipProjectId || '').trim()
  if (!rawId || !rawProjectId) return

  const dsn = `https://${rawId}@errors.pandaahh.com/${rawProjectId}`
  const appConfig = useAppConfig()
  const version = (appConfig.version as string) || '1.0.0'

  Sentry.init({
    app: nuxtApp.vueApp,
    dsn,
    environment: (config.public.server as string) || 'production',
    release: `bot-riven-admin@${version}`,
    tracesSampleRate: 0.01,
    sendClientReports: false,
    ignoreErrors: [
      /Failed to fetch dynamically imported module/i,
      /Importing a module script failed/i,
      /error loading dynamically imported module/i,
      /Loading chunk .* failed/i,
    ],
  })
})
